module.exports = __webpack_public_path__ + "static/img/upload-success-en.d6206ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/upload-success-en.png
// module id = 2/II
// module chunks = 1